import * as React from 'react';
import styled from 'styled-components';
import { colors } from 'bench-style-constants';

// Weird fix for ::before box-shadows disappearing otherwise.
const Wrapper = styled.div`
  position: relative;
  z-index: 0;
`;

const Pop = styled.div<{ left: string | null; right: string | null }>`
  position: relative;
  margin-top: 16px;
  background: ${colors.white};
  border-radius: 4px;
  box-shadow: 0 0 4px 0 rgba(0, 0, 0, 0.2);

  &::before,
  &::after {
    content: '';
    position: absolute;
    top: 0;
    width: 20px;
    height: 20px;
    margin: -10px 0 0 -10px;
    background: ${colors.white};
    transform-origin: 50% 50%;
    transform: rotate(45deg);

    /* FIXME: Eslint is forcing the spacing to be broken :/ */
    ${({ right, left }) => {
      if (right) {
        return `right: ${right};`;
      }

      if (left) {
        return `left: ${left};`;
      }

      return 'left: 50%;';
    }};
  }

  &::before {
    z-index: -1;
    box-shadow: 0 0 4px 0 rgba(0, 0, 0, 0.2);
  }
`;

export type PopoverProps = {
  children: React.ReactNode;
  left: string | null;
  right: string | null;
};

const Popover = ({ children, left, right }: PopoverProps) => (
  <Wrapper>
    <Pop left={left} right={right}>
      {children}
    </Pop>
  </Wrapper>
);

Popover.defaultProps = {
  left: null,
  right: null,
};

export default Popover;
